export const STOCK_HERMES_SKILLS = "Stock Hermes";
export const GROWTHOS_SKILLS = "GrowthOS";
export const BRAND_SPECIFIC_SKILLS = "Brand-specific";

export const SKILL_CATEGORIES = Object.freeze([
  STOCK_HERMES_SKILLS,
  GROWTHOS_SKILLS,
  BRAND_SPECIFIC_SKILLS,
]);

export const SKILL_CATEGORY_DESCRIPTIONS = Object.freeze({
  [STOCK_HERMES_SKILLS]: "Core capabilities every agent starts with, supplied through Hermes.",
  [GROWTHOS_SKILLS]: "Shared GrowthOS packages installed across eligible agents.",
  [BRAND_SPECIFIC_SKILLS]: "Capabilities created for this workspace, or shared skills your agent adapted to your brand.",
});

const EXPLICIT_SCOPE_CATEGORY = Object.freeze({
  stock: STOCK_HERMES_SKILLS,
  stock_hermes: STOCK_HERMES_SKILLS,
  hermes_stock: STOCK_HERMES_SKILLS,
  builtin: STOCK_HERMES_SKILLS,
  official: STOCK_HERMES_SKILLS,
  growthos: GROWTHOS_SKILLS,
  growth_os: GROWTHOS_SKILLS,
  shared: GROWTHOS_SKILLS,
  xscale_shared: GROWTHOS_SKILLS,
  xscale_base: GROWTHOS_SKILLS,
  brand_specific: BRAND_SPECIFIC_SKILLS,
  brand_local: BRAND_SPECIFIC_SKILLS,
  local: BRAND_SPECIFIC_SKILLS,
  workspace_customized: BRAND_SPECIFIC_SKILLS,
});

function normalizeToken(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function categorizeSkill(skill) {
  // Supabase runtime provenance is canonical. Unknown/missing classifications
  // fail closed to Brand-specific and are never inferred from skill, agent, or
  // client names, or from free-text change history.
  return EXPLICIT_SCOPE_CATEGORY[normalizeToken(skill?.scope)] ?? BRAND_SPECIFIC_SKILLS;
}
